export default __webpack_public_path__ + "static/lozenge-do-4-dark-0c86610db1967ef15b7392f1b017d438a6b0a31b8815e4458bf2ce233fc338b0.png";